import SchemaTreeViewWithButtons from "./SchemaTreeViewWithButtons";

export default SchemaTreeViewWithButtons;
